var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownloadGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99372 9.25105C6.65201 8.91632 6.09799 8.91632 5.75628 9.25105C5.41457 9.58579 5.41457 10.1285 5.75628 10.4632L8.38128 13.0347C8.72299 13.3694 9.27701 13.3694 9.61872 13.0347L12.2437 10.4632C12.5854 10.1285 12.5854 9.58579 12.2437 9.25105C11.902 8.91632 11.348 8.91632 11.0063 9.25105L9.875 10.3592L9.875 5.57143H14.25C15.2165 5.57143 16 6.33894 16 7.28571V13.2857C16 14.2325 15.2165 15 14.25 15H3.75C2.7835 15 2 14.2325 2 13.2857V7.28571C2 6.33894 2.7835 5.57143 3.75 5.57143H8.125L8.125 10.3592L6.99372 9.25105Z",
    fill: "#DDDDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 3.85714C8.125 3.38376 8.51675 3 9 3C9.48325 3 9.875 3.38376 9.875 3.85714L9.875 5.57143H8.125L8.125 3.85714Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadGray);
export default __webpack_public_path__ + "static/media/Icon_download_Gray.8736396bdc27c685df411e439437baf2.svg";
export { ForwardRef as ReactComponent };